shvenergy.dealerlist = (function ($) {
    "use strict";

    function init() {
        if ($("#anchor-menu").innerHeight() < 50) {
            if (document.body.dataset.totopEnabled === 'True') {
                if (window.matchMedia('(min-width: 640px)').matches) {
                    $(".dealer-list__anchor-list").css({ "top": "10px" });
                } else {
                    $(".dealer-list__anchor-list").css({ "top": "0px" });
                }
            } else {
                if (window.matchMedia('(min-width: 0px)').matches && window.matchMedia('(max-width: 640px)').matches) {
                    $(".dealer-list__anchor-list").css({ "top": "48px" });
                } else if (window.matchMedia('(min-width: 641px)').matches && window.matchMedia('(max-width: 1200px)').matches) {
                    $(".dealer-list__anchor-list").css({ "top": "60px" });
                } else {
                    $(".dealer-list__anchor-list").css({ "top": "81px" });
                }
            }
        }
    }

    init();

})(jQuery);